import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdatePaymentMethodForm from "../../forms/CreateOrUpdatePaymentMethodForm";

const UpdatePaymentMethodModal = ({
  open,
  onClose,
  method,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${method.name}`}
    width="md"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdatePaymentMethodForm
      isEditing={true}
      paymentMethod={method}
      loading={loading}
    />
  </AppModal>
);

export default UpdatePaymentMethodModal;
